<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">消費税税率検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          @click="load"
          class="btn-search"
          v-permit.SHARP_CTR_SEARCH
        >{{$t('app.buttons.search')}}</v-btn>
        <v-btn to="/m0191/new" v-permit.SHARP_CTR_NEW>{{$t('app.buttons.new')}}</v-btn>
        <v-btn
          :disabled="selected.length!==1"
          @click="edit"
          v-permit.SHARP_CTR_EDIT.SHARP_CTR_DETAIL
        >{{$t('app.buttons.edit')}}</v-btn>
        <v-btn
          :disabled="selected.length===0"
          @click="remove"
          v-permit.SHARP_CTR_DELETE
        >{{$t('app.buttons.remove')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs6>
              <v-text-field clearable label="消費税 CD" v-model="query.code"></v-text-field>
            </v-flex>
            <v-flex md3 sm6 xs6>
              <v-text-field clearable label="消費税 名称" v-model="query.name"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-0"
        item-key="code"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
          </td>
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.taxTypeName}}</td>
          <td>{{ props.item.rate}}</td>
          <td>{{ props.item.startDate}}</td>
          <td>{{ props.item.endDate}}</td>
          <td>{{ props.item.freightCalcStartDate}}</td>
          <td>{{ props.item.freightCalcEndDate}}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    query: {},
    selected: [],
    results: [],
    loading: false,
    pagination: {
      page: 1
    },

    headers: [
      { text: '消費税 CD', value: 'code', sortable: false },
      { text: '消費税 名称', value: 'name', sortable: false },
      { text: '消費税 税率', value: 'rate', sortable: false },
      { text: '適応開始日', value: 'startDate', sortable: false },
      { text: '適応終了日', value: 'endDate', sortable: false },
      { text: '国際セグメント適応開始日', value: 'startDate', sortable: false },
      { text: '国際セグメント適応終了日', value: 'endDate', sortable: false }
    ]
  }),
  methods: {
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable()
        }
      }
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http.get('/consumption-tax-rates', this.params()).then(res => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
        this.results = res.data.content
        this.loading = false
        this.selected = []
      })
    },
    edit() {
      this.$router.push({
        name: 'EditM0191',
        query: { id: this.selected[0].id }
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          Promise.all(
            this.selected.map(s => {
              return this.$http.delete(`/consumption-tax-rates/${s.id}`)
            })
          ).then(() => {
            this.load()
            this.selected = []
          })
        }
      )
    }
  },
  mounted() {
    this.$loadParams()
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    }
  }
}
</script>
